import React ,{ useContext } from 'react'
import './styles.scss'

import contractContext from '../../../store/contexts/contractContext'

import UserInfoRow from '../../../components/UserInfoRow'

import SingingContract from '../../../assets/svgs/SigningContract'

const CreatedContract = () => {
  const {
    contract: { users },
  } = useContext(contractContext)

  return (
    <div className='created-contract-wrapper'>
      <h1>O contrato foi gerado com sucesso</h1>
      <div className='icon-spacer'>
        <SingingContract />
      </div>
      <div className='users-column'>
        {users.map((user) => (
          <UserInfoRow key={user.id} name={user.name} email={user.email} className='user-row img-formatter' />
        ))}
      </div>
      <p>
        Em breve você e os moradores receberão o contrato de aluguel nos e-mails cadastrados para ser assinado
        eletronicamente.
      </p>
      <a className='payment-link' href='https://www.asaas.com/c/472840877352'>
        Fazer pagamento (R$10,00)
      </a>
    </div>
  )
}

export default CreatedContract
